export const MgmOffResourcesEn = {
    title: "Recommend and <b>earn</b>",
    description: "We are sorry, but you cannot recommend goodie cashback right now.",
    mgmActiveDescription:
        "Log in to check if you can participate in the Recommend and Earn program!",

    recommendAndEarn: {
        title: "Do you keep<br><b>saving?</b>",
        info: "You can still do cashback purchasing with goodie.",
        btnText: "I'm starting shopping!",
    },
};
